import {
    CatalogItem,
    MappedCatalogItem,
} from 'entities/CatalogItem/model/types/CatalogItemSchema';

export type SummaryByCategories = Record<
    string,
    {
        count: number;
        cost: string;
    }
>;

export const getGroupSummary = (
    groupedItems: Record<string, CatalogItem[]>,
    selectedItems: Record<string, Partial<MappedCatalogItem>>,
) => {
    const result: Record<
        string,
        {
            count: number;
            cost: number;
        }
    > = {};
    Object.entries(groupedItems).forEach(([categoryId, items]) => {
        let count = items.length;
        let totalCost = 0;

        items.forEach((item) => {
            let itemTotalPrice = 0;
            if (item.selectedProposals?.length > 0) {
                item.selectedProposals?.forEach((selectedProposal) => {
                    itemTotalPrice +=
                        (selectedProposal.price || 0) *
                        (selectedProposal.selectedQuantity || 0);
                });
            } else {
                const selectionKey = item.uuid ?? item.id;
                itemTotalPrice =
                    Number(item?.price) * selectedItems?.[selectionKey]?.qty;
            }

            totalCost += itemTotalPrice;
        });

        result[categoryId] = {
            count,
            cost: totalCost,
        };
    });
    return result;
};
